import UploadFloorPlan from './UploadFloorPlan';

export default UploadFloorPlan;
